import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import LatviaImage from '../components/latvia.jpeg';

function Year2015() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
        <h1>2015 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back
      </button>
        <div className="location-grid">
          {/* Latvia Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/latvia')} // Redirect to /latvia
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${LatviaImage})` }}
            ></div>
            <p className="location-name">Latvia</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2015;